export default {
  centralRegistryforModuleCertificatesZEREZ: "Zentrales Register für Einheiten- und Komponentenzertifikate ZEREZ",
};
